import { get } from "../utils/api/apiCaller";
import { ENDPOINTS } from "../utils/api/endpoints";
import type { ApiResponse } from "../utils/api/apiClient";

export const getCompanies = (
  params?: Record<string, unknown>,
): Promise<ApiResponse> => get(ENDPOINTS.COMPANIES.LIST, params);

export const getCompanyBranches = (
  id: string,
  params?: Record<string, unknown>,
): Promise<ApiResponse> => get(ENDPOINTS.COMPANIES.BRANCHES(id), params);
